module.exports = __webpack_public_path__ + "img/icon_projects.fabeadd0.svg";